import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Badge
} from 'reactstrap';
import moment from 'moment';
import { cancelAttendance } from '../../api/attendance';
const CancelRequestModal = ({
  modalOpenState,
  closeModalHandler,
  attendanceList,
  fetchNewData,
  setCurrentCancelCount,
  setPaidLeaveConsumed,
  setPaidLeaveRequested,
  setSaturdayLeave,
  setSaturdayLeaveRequested,
  setUnpaidLeave,
  setUnpaidLeaveRequested
}) => {
  const [loadingId, setLoadingId] = useState(null);
  const pendingCancelRequests = attendanceList.filter(
    (item) => item.cancel_requested_at && item.cancel_action === 'Pending'
  );

  useEffect(() => {
    if (typeof setCurrentCancelCount === 'function') {
      setCurrentCancelCount(pendingCancelRequests.length);
    }
  }, [pendingCancelRequests.length, setCurrentCancelCount]);

  function calculateLeaveDays(start, end) {
    const s = new Date(start);
    const e = new Date(end);
    return Math.floor((e - s) / (1000 * 60 * 60 * 24)) + 1;
  }

  const handleAction = async (attendanceId, action) => {
    setLoadingId(attendanceId);
    const attendanceInfo = attendanceList.find((i) => i._id === attendanceId);
    await cancelAttendance(attendanceId, action);
    // update leave state locally on cancel approve
    if (action === 'Approved' && attendanceInfo) {
      const leaveDays = calculateLeaveDays(
        attendanceInfo.start_date,
        attendanceInfo.end_date
      );
      if (attendanceInfo.type === 'Paid Leave') {
        if (setPaidLeaveConsumed) {
          setPaidLeaveConsumed((prev) => Math.max(0, prev - leaveDays));
        }
        if (setPaidLeaveRequested) {
          setPaidLeaveRequested((prev) => Math.max(0, prev - leaveDays));
        }
      }
      if (attendanceInfo.type === 'Saturday Leave') {
        if (setSaturdayLeave) {
          setSaturdayLeave(0);
        }
        if (setSaturdayLeaveRequested) {
          setSaturdayLeaveRequested(0);
        }
      }
      if (attendanceInfo.type === 'Unpaid Leave') {
        if (setUnpaidLeave) {
          setUnpaidLeave((prev) => Math.max(0, prev - leaveDays));
        }
        if (setUnpaidLeaveRequested) {
          setUnpaidLeaveRequested((prev) => Math.max(0, prev - leaveDays));
        }
      }
    }
    setLoadingId(null);
    if (fetchNewData) {
      fetchNewData();
    }
  };

  return (
    <Modal isOpen={modalOpenState} size="xl" backdrop="static">
      <ModalHeader toggle={closeModalHandler}>Cancel Requests</ModalHeader>
      <ModalBody>
        {pendingCancelRequests.length === 0 ? (
          <p className="text-center mb-0">No pending cancel requests</p>
        ) : (
          <Table bordered responsive>
            <thead>
              <tr>
                <th>Staff</th> <th>Reason</th> <th>Start Date</th>
                <th>End Date</th> <th>Requested At</th> <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {pendingCancelRequests.map((item) => (
                <tr key={item._id}>
                  <td>{item.staff_id?.name || '-'}</td>
                  <td>{item.leave_reason}</td>
                  <td>{moment(item.start_date).format('DD-MM-YYYY')}</td>
                  <td>{moment(item.end_date).format('DD-MM-YYYY')}</td>
                  <td>
                    {moment(item.cancel_requested_at).format(
                      'DD-MM-YYYY HH:mm'
                    )}
                  </td>
                  <td>
                    <Badge color="warning">Pending</Badge>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      color="success"
                      className="mr-2"
                      disabled={loadingId === item._id}
                      onClick={() => handleAction(item._id, 'Approved')}
                    >
                      Approve
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      disabled={loadingId === item._id}
                      onClick={() => handleAction(item._id, 'Rejected')}
                    >
                      Reject
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={closeModalHandler}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default CancelRequestModal;
